import { render } from "./snackbar.vue?vue&type=template&id=25acc852&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"

import "./snackbar.vue?vue&type=style&index=0&id=25acc852&scoped=true&lang=css"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25acc852"]])

export default __exports__